import React, {useRef} from "react";
import Form from "../forms/form";
import { FaCheckCircle } from "react-icons/fa";
import { IoIosCloseCircle } from "react-icons/io";
import flower45 from "../../img/formats_flowers.png"

import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';

function Formats({formatsData}) {


    return (
        formatsData ?
            formatsData.map((item, index) => (
                <>
                    <section id="formats" className="formats relative py-20 overflow-hidden" key={index}>
                        <div className="lg:p-20 md:p-10 p-5 flex justify-center items-center" id="formatscontainer">
                            <div
                                className="max-w-screen-lg mx-auto bg-[#f7eae8] overflow-hidden relative z-30 w-full py-10 "
                                >

                                {
                                    item.format.map((item, index) => (
                                        <div className="grid grid-col-1 lg:grid-cols-[40%,60%]" key={index}
                                             id="formatsitem">
                                            <div className="md:p-8 p-2">
                                                <h3 className="mb-6 text-3xl uppercase">У пакет входить</h3>
                                                <div>
                                                    <ul>
                                                        {item.format_items.map((item, index) => (
                                                            <li className="flex flex-wrap my-4"
                                                                key={index}>{item.forat_checkbox ? <FaCheckCircle
                                                                    className="text-[#8f78be] text-[20px] w-[20px] mr-[10px]"/> :
                                                                <IoIosCloseCircle className="text-red-600"/>} <span
                                                                className="w-[calc(100%-30px)]">{item.forat_item}</span>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="md:p-8 p-2">
                                                <Form nameform="form_uchast_intext_done"/>
                                            </div>
                                        </div>
                                    ))
                                }

                            </div>
                        </div>
                        <ScrollAnimation animatePreScroll="true" offset="1"
                            animateIn="animate__fadeInRight"
                            className="bg-contain bg-repeat bg-bottom block absolute left-0 -bottom-[100px] h-full w-full z-10"
                            style={{backgroundImage: `url(${flower45})`}} />
                    </section>
                </>)) : ''
    )
}

export default Formats